import Router from './Router';

export default Router;



// WEBPACK FOOTER //
// ./src/pages/gdpr-assessment-tool/containers/Router/index.js